/* eslint-disable no-unused-vars */
import axios from 'axios'
import { userHome as uh, addItem as add } from './../lib/userLib'
const apiUrl = process.env.VUE_APP_ROOT_API
const jwtName = process.env.VUE_APP_JWT_NAME

const actions = {
  // page title
  displayPageTitle: function(context, title) {
    context.commit('setPageTitle', title)
  },

  // progress bar
  displayProgBar: function(context) {
    context.commit('showProgBar')
  },
  closeProgBar: function(context) {
    context.commit('hideProgBar')
  },

  // alert
  displayAlert: function(context, payload) {
    context.commit('setAlertCol', payload.color)
    context.commit('setAlertMsg', payload.message)
    context.commit('showAlert')    
  },
  closeAlert: function(context) {
    context.commit('setAlertCol', 'info')
    context.commit('setAlertMsg', '')
    context.commit('hideAlert') 
  },
  assignParam: async function(context) {
    const obj = null
    await axios.get(apiUrl+'/admin/param')
    .then((response) => {
      response.data.data.rows.forEach(element => {          
        context.commit('setRules', element)
      })              
    })
    .catch((error) => {
      console.log(error)
    }) 
  },

  // auth - login
  loginState: function(context, obj) {
    const ux = uh.find(el => el.jenis === obj.user.roles)
    const drawItemUser = ux.drawer.content.slice()
    const drawItemUnlada = [].concat(ux.drawer.content, add).slice()
    // logical    
    context.commit('setAuth', obj.user)
    context.dispatch('assignToken', obj.token)
    localStorage.setItem(jwtName, obj.token)
    axios.defaults.headers.common['Authorization'] = obj.token    
    // user interface 

    ux.drawer.content = null
    if (obj.user.divisi === 'unlada') {
      ux.drawer.content = drawItemUnlada.slice()
    }
    else {
      ux.drawer.content = drawItemUser.slice()
    }
   
    context.dispatch('assignDrawer', ux.drawer)
    context.commit('setUserHome', ux.path)
    context.dispatch('closeDrawer')
    // rules
    context.dispatch('assignParam')
    // vendor
    if (obj.user.roles === 'vendor' || obj.user.roles === 'person')
      context.dispatch('ven/assignVendor', obj.vendor)
  },
  login: function(context, cred) {
    context.dispatch('displayProgBar')
    return new Promise((resolve, reject) => {
      axios.post(apiUrl+'/login', { userId: cred.userId, password: cred.password })
      .then((response) => {
        const token = response.data.data.token
        const user = response.data.data.user  
        const vendor = response.data.data.vendor      
        context.dispatch('loginState', { user: user, token: token, vendor: vendor })
        resolve(user)
      })
      .catch((error) => {
        context.dispatch('displayAlert', {color: 'error', message: error.response.data.message })
        localStorage.removeItem(jwtName)
        reject(error)
      })
      .finally(() => {
        context.dispatch('closeProgBar')
      })       
    })
  },
  logout: function(context) {
    return new Promise((resolve, reject) => {
      context.dispatch('logoutState')
      resolve()
    })
  },
  logoutState: function(context) {
    // logical    
    context.commit('clearAuth')
    context.commit('clearToken')
    localStorage.removeItem(jwtName)
    delete axios.defaults.headers.common['Authorization']
    // user interface
    context.commit('clearUserHome')
    context.dispatch('closeDrawer')
    // vendor
    context.dispatch('ven/releaseVendor')
    // clear all
    context.dispatch('displayPageTitle', '')
  },
  assignToken: function(context, token) {
    context.commit('setToken', token)
  },

  // drawer
  assignDrawer: function(context, draw) {
    context.commit('setDrawerColor', draw.color)
    context.commit('setDrawerContent', draw.content)
  },
  releaseDrawer: function(context) {
    context.commit('setDrawerColor', null)
    context.commit('setDrawerContent', null)
  },
  toggleDrawer: function(context) {
    context.commit('klikDrawer')
  },
  closeDrawer: function(context) {
    context.commit('closeDrawer')
  }
}

export default actions